import {Component, OnInit} from '@angular/core';
import {Localization} from "../../../../common/enums/localization";
import {InterventionTeamContactResource} from "../intervention-team-contact-resource.service";
import {InterventionTeamContactDto} from "../intervention-team-contact.dto";
import {UntypedFormControl} from "@angular/forms";
import {debounceTime, filter, map} from "rxjs/operators";
import {TeamContactDialogComponent} from "../new-team-contact-dialog/team-contact-dialog.component";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-contacts-manager',
  templateUrl: './contacts-manager.component.html',
  styleUrls: ['./contacts-manager.component.scss']
})
export class ContactsManagerComponent implements OnInit {

  public readonly Localization = Localization;
  public filteredContacts: InterventionTeamContactDto[] = []
  public loading = false;
  public selectedContact: InterventionTeamContactDto;
  public readonly searchField = new UntypedFormControl();
  private readonly searchPhrase$ = this.searchField.valueChanges.pipe(debounceTime(500));
  private contacts: InterventionTeamContactDto[] = [];
  private readonly contactId$ = this.route.paramMap.pipe(map(params => params.get('id')));

  constructor(
    private readonly contactsResource: InterventionTeamContactResource,
    private readonly dialogs: MatDialog,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
  }

  public filterContacts(searchPhrase?: string) {
    if (searchPhrase?.length > 0) {
      return this.filteredContacts = this.contacts.filter(({firstName, lastName}) => {
        return `${firstName} ${lastName}`.toLowerCase().includes(searchPhrase?.toLowerCase());
      });
    }
    return this.filteredContacts = this.contacts
  }

  async ngOnInit(): Promise<void> {
    await this.fetchContacts();
    this.searchPhrase$.subscribe(phrase => this.didSearchFor(phrase));
    this.contactId$.subscribe((id: string) => this.selectById(id));
  }

  public didDeleted(contactDto: InterventionTeamContactDto): void {
    console.log('Removing deleted contact')
    this.contacts = this.contacts.filter(({id}) => id !== contactDto.id);
    this.filterContacts(this.searchField.value);
    this.initialSelection();
  }

  public async createContact() {
    const contact = await this.showCreateContactDialog();
    if (contact) {
      this.contacts.push(contact);
      this.selectedContact = contact;
    }
  }

  public async browse(contact: InterventionTeamContactDto) {

    await this.router.navigate(['/', 'maintenance', 'intervention-teams', 'contacts', contact.id]);
  }

  private showCreateContactDialog(): Promise<InterventionTeamContactDto> {
    return this.dialogs.open<TeamContactDialogComponent, never, InterventionTeamContactDto>(TeamContactDialogComponent, {panelClass: 'full-bleed'})
      .afterClosed().pipe(filter(r => !!r)).toPromise();
  }

  private async fetchContacts() {
    this.loading = true;
    this.contacts = this.filteredContacts = (await this.contactsResource.get().toPromise()).items;
    this.initialSelection();
    this.loading = false;
  }

  private initialSelection(): void {
    if (!this.filteredContacts.find(({id}) => id === this.selectedContact?.id)) {
      this.selectedContact = this.filteredContacts[0];
    }
  }

  private didSearchFor(phrase: string): void {
    this.filterContacts(phrase);
    this.initialSelection();
  }

  private selectById(contactId: string): void {
    console.log('seelect', contactId)
    const selection = this.filteredContacts.find(({id}) => id === contactId);
    if (selection) {
      this.selectedContact = selection;
    }
  }

}
